import { constants } from "redux/constants/redux-constants";

const initialState = {
  keyword: "",
  context: null,
  // Outcome of the last settled keyword-driven query (published by the
  // DataTable datasource; consumed by the copilot filter action). Cleared the
  // moment a new keyword is set so a waiter never matches a stale result.
  result: null,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_SEARCH_KEYWORD:
      return {
        ...state,
        keyword: action.payload.keyword,
        context: action.payload.context,
        result: null,
      };
    case constants.SET_SEARCH_RESULT:
      return {
        ...state,
        result: {
          context: action.payload.context,
          status: action.payload.status,
          count: action.payload.count,
          at: action.payload.at,
          // The keyword this result settled FOR — select's K3 interlock matches
          // it against the active keyword before resolving a rank.
          keyword: action.payload.keyword,
        },
      };
    default:
      return state;
  }
};

export default searchReducer;
